/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
// import ReactModal from "react-modal";
import { Button, Modal } from "react-bootstrap";
// import JobsViewMapComponent from "../../MapView";
// import JobMap from "./JobMap";
import JobMapRoute from "./JobMapRoute";

const EmptyView = () => <p>No job data</p>;

// const modalStyle = {
//   overlay: { zIndex: 6, backgroundColor: "rgba(0, 0, 0, 0.75)" },
//   content: { zIndex: 7, left: "200px", right: "200px" }
// };

// class ViewOnMap extends Component {
//   state = {
//     showModal: false,
//     activeJobId: "",
//     display: "Details"
//   };
//
//   handleJobMarkerToggle = job => {
//     this.setState({ activeJobId: job.externalId });
//   };
//
//   handleOpenModal = () => this.setState({ showModal: true });
//
//   handleCloseModal = () => this.setState({ showModal: false });
//
//   isLatitude = lat => isFinite(lat) && Math.abs(lat) <= 90;
//
//   isLongitude = lng => isFinite(lng) && Math.abs(lng) <= 90;
//
//   render() {
//     const { jobs } = this.props;
//
//     if (!jobs.length) {
//       return "";
//     }
//
//     let jobsWithLocation = jobs.filter(
//       job => job.stop.location && job.stop.location.GPS
//     );
//     if (!jobsWithLocation.length) {
//       return "";
//     }
//
//     jobsWithLocation = jobsWithLocation.filter(j =>
//       this.isLatitude(j.stop.location.GPS.Lat)
//     );
//
//     if (!jobsWithLocation.length) {
//       return "";
//     }
//
//     return (
//       <span>
//         <button className="btn pull-right" onClick={this.handleOpenModal}>
//           VIEW ON MAP
//         </button>
//         <ReactModal isOpen={this.state.showModal} style={modalStyle}>
//           <div className="map-view">
//             <h1>
//               Map View<button
//                 className="btn btn-small pull-right"
//                 onClick={this.handleCloseModal}
//               >
//                 Close
//               </button>
//             </h1>
//             <div className="clearfix" />
//           </div>
//
//           {this.props.jobs.length ? (
//             <JobMapRoute jobs={this.props.jobs} />
//           ) : (
//             <EmptyView />
//           )}
//         </ReactModal>
//       </span>
//     );
//   }
// }
// ViewOnMap.propTypes = {
//   jobs: PropTypes.array.isRequired
// };

class ViewOnMap extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  isLatitude = lat => isFinite(lat) && Math.abs(lat) <= 90;

  isLongitude = lng => isFinite(lng) && Math.abs(lng) <= 90;

  render() {
    const { jobs } = this.props;

    if (!jobs.length) {
      return "";
    }

    let jobsWithLocation = jobs.filter(
      job => job.stop.location && job.stop.location.GPS
    );
    if (!jobsWithLocation.length) {
      return "";
    }

    jobsWithLocation = jobsWithLocation.filter(j =>
      this.isLatitude(j.stop.location.GPS.Lat)
    );

    if (!jobsWithLocation.length) {
      return "";
    }

    return (
      <span>
        <Button
          className="pull-right"
          bsStyle="primary"
          onClick={this.handleShow}
        >
          VIEW ON MAP
        </Button>

        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>View On Map</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.props.jobs.length ? (
              <JobMapRoute jobs={this.props.jobs} />
            ) : (
              <EmptyView />
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose}>Close</Button>
          </Modal.Footer>
        </Modal>
      </span>
    );
  }
}
ViewOnMap.propTypes = {
  jobs: PropTypes.array.isRequired
};

export default ViewOnMap;



// WEBPACK FOOTER //
// ./src/components/jobs/ViewOnMap.js